import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    offer: {
      try: 'Profiter de l’offre',
    },
    offers: {
      seeAll: 'Voir toutes les offres',
      similar: 'Offres similaires',
    },
  },
  fr: {
    offer: {
      try: 'Profiter de l’offre',
    },
    offers: {
      seeAll: 'Voir toutes les offres',
      similar: 'Offres similaires',
    },
  },
});

export default locales;
